import {atom} from 'jotai'

import {Item} from '../domain'

const initialItem: Item = {
  id: '',
  status: 1,
  usageLimit: 1,
  attribute1: '',
  attribute2: '',
  attribute3: null,
  attribute4: null,
  termsAndConditions: '',
  isSubscriptionPackage: false,
  attribute5: null,
  isEditable: true,
  attribute6: null,
  attribute7: null,
  attribute8: null,
  duration: null,
  availableFrom: '',
  availableUntil: '',
  barcode: '',
  blackListedForPoints: null,
  categoryID: '',
  detail: '',
  discount: 0,
  discountFixAmount: 0.0,
  discountFixAmountBase: 0.0,
  displayOrder: 0,
  eligibleForPoints: 0,
  familyID: null,
  imagesData: null,
  name: '',
  lowStockThreshold: 0,
  payWithPoints: 0,
  price: 24.99,
  priceBase: 0.0,
  priceWithoutTax: 0.0,
  priceWithoutTaxBase: 0.0,
  itemBrandID: null,
  itemID: null,
  itemTitle: null,
  itemTypeID: '',
  purchaseType: 1,
  ribbon: 0,
  salePrice: 0.0,
  salePriceBase: 0.0,
  salesUnitID: null,
  sku: '',
  soldIndividually: 0,
  stockQuantity: 1,
  subCategoryID: '',
  taxRate: 5,
  taxStatus: 0,
  visibility: 0,
  directSale: false,
  eStore: false,
  paymentLink: false,
}

export const detailAtom = atom<Item>(initialItem)

export const categoriesAtom = atom<
  {
    id: string
    name: string
    status: number
  }[]
>([])

export const subCategoriesAtom = atom<
  {
    id: string
    name: string
    status: number
  }[]
>([])

export const familysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])

export const visibilitysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])
